import React, {Component} from 'react';
import Select from 'react-select';
import {
    Alert,
    Button,
    Card,
    CardBody,
    CardSubtitle,
    CardTitle,
    Col,
    CustomInput,
    Form,
    FormGroup,
    Input,
    Label,
    Media,
    Row,
} from 'reactstrap';

import companyValidator from '../../helpers/companyValidator';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {
    delCompany,
    deleteCompanyLogo,
    fetchCompanies,
    fetchCompanyAvailableLanguages,
    updateSingleCompany,
    uploadCompanyLogo
} from '../../actions/companyActions';
import {fetchCities, fetchCountries} from '../../actions/geoActions';
import {updateCompanyAttributes} from '../../actions/attributesActions';
import {closeAlert} from '../../actions/commonsActions';
import {ACTIVE, API_BASE_URL, BLOCKED, GUEST, NOT_APPROVED, SUPER_ADMIN} from '../../helpers/constants';
import {I18n} from '../../I18n/components/Company';
import 'react-table/react-table.css';
import './company.css';
import '../../assets/scss/all/custom/_spinner.scss';
import profilephoto from '../../assets/images/users/1.jpg';
import swal from 'sweetalert'
import LogoUpload from "./LogoUpload";
import spinner from "../../assets/images/spinner.gif";
import {isCompanyLogoPermission} from "../../helpers/companyService";
import CompanyTypeSelector from "./CompanyTypeSelector";

class Company extends Component {

    constructor(props) {
        super(props);
        this.state = {
            newCompany: {
                id: null,
                name: '',
                types: [],
                countryCode: '',
                cityGeonameId: '',
                manager: '',
                phone: '',
                email: '',
                skype: '',
                status: '',
                newUserDefaultPassword: '',
                languageId: 0
            },
            currentCompany: {
                id: null,
                name: '',
                types: [],
                countryCode: '',
                cityGeonameId: '',
                manager: '',
                phone: '',
                email: '',
                skype: '',
                status: '',
                newUserDefaultPassword: '',
                languageId: 0
            },
            dateNow: Date.now(),
            isLogoLoaded: false,
            isDefaultLogo: false,
            modal: false,
            isOkModal: false,
            activeCompanyId: null,
            editMode: false,
            isShowDefaultPassword: false
        };
        this.validators = companyValidator;
    }

    componentDidMount() {
        (async () => await this.props.fetchCompanyAvailableLanguages())();
        this.getGeo().then(() => {
            return this.props.fetchCompanies({
                lang: this.props.lang
            })
        }).then(res => {
            if (res) {
                const company = this.props.companies[0];
                this.setState({
                    newCompany: company,
                    currentCompany: company,
                    isShowDefaultPassword: !!(company.newUserDefaultPassword && company.newUserDefaultPassword.length > 0)
                });
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.lang !== prevProps.lang) {
            (async () => {
                await this.props.fetchCompanyAvailableLanguages();
                await this.getGeo();
            })();
        }
    }

    getGeo = async () => {
        try {
            const countries = await this.props.fetchCountries({
                lang: this.props.lang
            });
            const cities = await this.props.fetchCities({
                lang: this.props.lang,
                countryCode: this.props.companies[0].countryCode
            });
        } catch (err) {
            console.error(err);
        }
    };

    updateCountry = async data => { // get country and sities
        const selectedCountry = data.value;
        try {
            const cities = await this.props.fetchCities({
                lang: this.props.lang,
                countryCode: selectedCountry
            });
        } catch (err) {
            console.error(err);
        }
    };

    updateCompanyAttributesList = async attributes => {
        await this.props.updateCompanyAttributes(attributes);
        setTimeout(() => {
            this.props.closeAlert();
        }, 3000);
    };

    handleSubmit = event => {
        event.preventDefault();
        if (this.isFormValid() && this.state.editMode) {
            const sendData = {...this.state.newCompany};
            this.props.updateSingleCompany(sendData)
                .then(company => {
                    const currentCompany = {...this.state.currentCompany};
                    setTimeout(() => {
                        this.props.closeAlert();
                        if (currentCompany.types !== sendData.types) {
                            window.location.reload();
                        }
                    }, 3000);
                    this.setState(state => ({
                        editMode: false,
                        currentCompany: state.newCompany
                    }));
                }, error => {
                    throw new Error(error.statusText)
                })
        }
    };

    clearNewCompanyState = () => {
        this.setState(state => ({
            newCompany: state.currentCompany
        }), () => {
        });
    };

    onInputChange = event => {
        console.log('value', event.value);
    	let name, value;
    	if (event && event.value && typeof event.value === "string") {
			name = 'countryCode';
			value = event.value;
		} else if (event && event.value && typeof event.value === "number") {
			name = 'cityGeonameId';
			value = event.value;
		} else {
            name = event.target.name;
            value = event.target.value;
        }
        this.setState(state => ({
            newCompany: Object.keys(state.newCompany).reduce((res, key) => {
                if (key === name) {
                    let tempValue = [];
                    if (Array.isArray(state.newCompany[key])) {
                        tempValue = value.split(',');
                        tempValue = tempValue.length === 1 && tempValue[0] === '' ? [] : tempValue;
                    } else {
                        tempValue = value;
                    }
                    res[key] = tempValue; //(Array.isArray(state.newAttribute[key])) ? value.split(',') : value;
                } else {
                    res[key] = state.newCompany[key];
                }
                return res
            }, {})
        }));
        this.formValidators([name], value);
        this.setState({
            editMode: true
        });
    };

    onCompanyTypeChange = type => {
        const newCompany = {...this.state.newCompany};
        newCompany.types = type.value;
        this.setState({
            newCompany,
            editMode: true
        });
    };

    onLanguageChange = (event) => {
        const newCompany = {...this.state.newCompany};
        newCompany.languageId = event.value;
        this.setState({
            newCompany,
            editMode: true
        });
    };

    onPasswordShowChange = event => {
        const value = event.target.checked;
        this.setState({
            isShowDefaultPassword: value,
            editMode: true
        });
        if (value === false) {
            this.validators['newUserDefaultPassword'].errors = [];
            this.validators['newUserDefaultPassword'].state = value;
            this.validators['newUserDefaultPassword'].valid = true;
            const newCompany = {...this.state.newCompany};
            const currentCompany = {...this.state.currentCompany};
            newCompany['newUserDefaultPassword'] = '';
            currentCompany['newUserDefaultPassword'] = '';
            this.setState({
                newCompany,
                currentCompany
            })
        }
    };

    onLogoSelect = event => {
        if (!isCompanyLogoPermission(this.props.companies[0], this.props.authority)) {
            swal(
                I18n[this.props.lang].contactUsToAccessThis,
                "",
                "error")
            return;
        }
        const file = event.target.files[0];
        if (file.size > 5000000) { //5MB
            swal(
                I18n[this.props.lang].logoIsTooLarge,
                "",
                "error")
        } else if (file.type !== "image/png") {
            swal(
                I18n[this.props.lang].isNotAnImage,
                "",
                "error")
        } else {
            this.props.uploadCompanyLogo(this.state.newCompany.id, file);
        }
        this.setState({
            isLogoLoaded: false
        })
        setTimeout(() => this.setState({
            isDefaultLogo: false,
            dateNow: Date.now()
        }), 1000)
        event.target.value = ''
    }

    onLogoDelete = () => {
        if (!this.state.isDefaultLogo) {
            swal({
                title: I18n[this.props.lang].deleteLogoQuestion,
                icon: 'warning',
                buttons: [I18n[this.props.lang].no, I18n[this.props.lang].yes],
            }).then((response) => {
                if (response) {
                    this.setState({isLogoLoaded: false})
                    this.props.deleteCompanyLogo(this.state.newCompany.id);
                    this.setState({dateNow: Date.now()})
                    swal({
                        title: I18n[this.props.lang].logoWasDeleted,
                        icon: 'success'
                    });
                }
            });
        }
    }

    formValidators = (fieldName, value) => {
        this.validators[fieldName].errors = [];
        this.validators[fieldName].state = value;
        this.validators[fieldName].valid = true;
        this.validators[fieldName].rules.forEach(rule => {
            if (rule.test instanceof RegExp) {
                if (!rule.test.test(value)) {
                    if (!this.state.isShowDefaultPassword && fieldName === 'newUserDefaultPassword') {
                        return;
                    }
                    this.validators[fieldName].errors.push(rule.message);
                    this.validators[fieldName].valid = false;
                }
            } else if (typeof rule.test === 'function') {
                if (!rule.test(value)) {
                    this.validators[fieldName].errors.push(rule.message);
                    this.validators[fieldName].valid = false;
                }
            }

        });
    };

    isFormValid = () => {
        let status = true;
        Object.keys(this.validators).forEach(field => {
            if (this.validators[field].errors.length && !this.validators[field].valid) {
                status = false;
            }
        });
        return status;
    };

    showErrors = fieldName => {
        const validator = this.validators[fieldName];
        const result = '';
        if (validator && !validator.valid) {
            const errors = validator.errors.map((info, index) => {
                return (
                    <span className="error" key={index}>
           			 	* {info}
                        <br/>
          			</span>
                );
            });

            return <div className="error mb-2">{errors}</div>;
        }
        return result;
    };

    renderCountrySelect = () => {
        const options = this.props.countriesList.map(elem => (
            {value: elem.countryCode, label: elem.countryName}
        ));
        let label = '';
        const activeCountry = this.props.countriesList.find(elem =>
            elem.countryCode === this.state.newCompany.countryCode
        );
        if (activeCountry) {
            label = activeCountry.countryName;
        }
        return (
            <Select
                name="countryCode"
                closeMenuOnSelect={true}
                value={{value: this.state.newCompany.countryCode, label: label}}
                options={options}
                onChange={data => {
                    this.updateCountry(data);
                    this.onInputChange(data);
                }}
				styles={{
					control: (styles, { data, isSelected }) => ({
						...styles,
                        color: '#3e5569',
						backgroundColor: 'white',
                        borderColor: '#e9ecef'
					}),
                    singleValue: (styles, { data }) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
				}}
            />
        )
    };

    renderCitySelect = () => {
        const options = this.props.citiesList.map(elem => (
            {value: elem.geonameId, label: elem.name}
        ));
        let label = '';
        const activeCity = this.props.citiesList.find(elem =>
            elem.geonameId === this.state.newCompany.cityGeonameId
        );
        if (activeCity) {
            label = activeCity.name;
        }
        return (
            <Select
                name="cityGeonameId"
                closeMenuOnSelect={true}
                value={{value: this.state.newCompany.cityGeonameId, label: label}}
                options={options}
                onChange={data => {
                    this.onInputChange(data);
                }}
                styles={{
                    control: (styles, { data, isSelected }) => ({
                        ...styles,
                        color: '#3e5569',
                        backgroundColor: 'white',
                        borderColor: '#e9ecef'
                    }),
                    singleValue: (styles, { data }) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
                }}
            />
        )
    };

    renderCompanyLanguageSelect = () => {
        const options = this.props.companyLanguages.map(elem => (
            {value: elem.id, label: elem.name}
        ));
        let label = '';
        const activeLanguage = this.props.companyLanguages.find(elem =>
            elem.id === this.state.newCompany.languageId
        );
        if (activeLanguage) {
            label = activeLanguage.name;
        }
        return (
            <Select
                name="languageId"
                closeMenuOnSelect={true}
                value={{value: this.state.newCompany.languageId, label: label}}
                options={options}
                onChange={data => this.onLanguageChange(data)}
                styles={{
                    control: (styles, {data, isSelected}) => ({
                        ...styles,
                        color: '#3e5569',
                        backgroundColor: 'white',
                        borderColor: '#e9ecef'
                    }),
                    singleValue: (styles, {data}) => ({
                        ...styles,
                        color: '#3e5569'
                    }),
                }}
            />
        )
    };

    render() {
        const {lang, authority} = this.props;
        return (
            <div className='companies '>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${this.props.alert.alert.status}`}
                    isOpen={this.props.alert.isOpen || false}
                >
                    {this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-border-right mr-2"></i>{I18n[lang].companyTitle}
                        </div>
                    </CardTitle>
                    <CardBody>
                        <Row>
                            <Col xs="12" md="12" lg="3">
                                <Card>
                                    <CardBody>
                                        <div className="text-center mt-4">
                                            <h5 className="mt-2 user-modal__name">
                                                {this.state.newCompany.name}
                                            </h5>
                                            <img
                                                src={`${API_BASE_URL}/company/logo/${this.state.newCompany.id}?dateNow=${this.state.dateNow}`}
                                                style={this.state.isLogoLoaded ? {} : {display: 'none'}}
                                                onError={
                                                    (e) => {
                                                        if (this.state.newCompany.id == null) {
                                                            this.setState({isLogoLoaded: false})
                                                        } else {
                                                            e.target.onerror = null;
                                                            e.target.src = profilephoto
                                                            this.setState({isDefaultLogo: true})
                                                        }
                                                    }
                                                }
                                                onLoad={() => this.setState({isLogoLoaded: true})}
                                                width="150"
                                                alt="Company logo"
                                            />
                                            <Media
                                                className={this.state.isLogoLoaded
                                                    ? 'modal-buttons__download visually-hidden'
                                                    : 'modal-buttons__download'}
                                                object
                                                src={spinner}
                                                alt="upload spinner"
                                            />
                                            <CardTitle className="user-modal__name">
                                                {I18n[lang].companyLogo}
                                            </CardTitle>
                                            <LogoUpload
                                                onLogoSelect={this.onLogoSelect}
                                                lang={this.props.lang}
                                            />
                                            <CardSubtitle>
                                                <div className="companies-delete-logo-button"
                                                     onClick={this.onLogoDelete}>
                                                    {I18n[lang].deleteLogo}
                                                </div>
                                            </CardSubtitle>
                                        </div>
                                    </CardBody>
                                    <CardBody className="border-top">
                                        <div>
                                            <small className="text-muted">{I18n[lang].email}</small>
                                            <h6>{this.state.newCompany.email}</h6>
                                            <small className="text-muted pt-4 db">{I18n[lang].phone}</small>
                                            <h6>{this.state.newCompany.phone}</h6>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col xs="12" md="12" lg="9">
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit} className='new-attr__form'>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <Input type="hidden" name="id" id="id"
                                                           defaultValue={this.state.newCompany.id}/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup>
                                                        <Label for="name">{I18n[lang].name}</Label>
                                                        <Input
                                                            type="text"
                                                            name="name"
                                                            id="name"
                                                            value={this.state.newCompany.name}
                                                            onChange={this.onInputChange}
                                                        />
                                                        {this.showErrors('name')}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup>
                                                        <Label for="types">{I18n[lang].type}</Label>
                                                        {/*<Input*/}
                                                        {/*    type="select"*/}
                                                        {/*    name="types"*/}
                                                        {/*    id="types"*/}
                                                        {/*    value={this.state.newCompany.types[0]}*/}
                                                        {/*    onChange={this.onInputChange}*/}
                                                        {/*>*/}
                                                        {/*    <option value=""></option>*/}
                                                        {/*    <option value={RETAIL}>{COMPANY_TYPES.RETAIL}</option>*/}
                                                        {/*    <option value={DEV}>{COMPANY_TYPES.DEV}</option>*/}
                                                        {/*</Input>*/}
                                                        <CompanyTypeSelector
                                                            types={this.state.newCompany.types}
                                                            lang={lang}
                                                            isDisabled={authority !== SUPER_ADMIN}
                                                            onCompanyTypeChange={this.onCompanyTypeChange}
                                                        />
                                                        {this.showErrors('types')}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="4">
                                                    <FormGroup>
                                                        <Label for="countryCode">{I18n[lang].country}</Label>
                                                        {this.renderCountrySelect()}
                                                        {this.showErrors('countryCode')}
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" md="12" lg="4">
                                                    <FormGroup>
                                                        <Label for="cityGeonameId">{I18n[lang].city}</Label>
                                                        {this.renderCitySelect()}
                                                        {this.showErrors('cityGeonameId')}
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" md="12" lg="4">
                                                    <FormGroup>
                                                        <Label for="languageId">{I18n[lang].language}</Label>
                                                        {this.renderCompanyLanguageSelect()}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup>
                                                        <Label for="manager">{I18n[lang].manager}</Label>
                                                        <Input
                                                            type="text"
                                                            name="manager"
                                                            id="manager"
                                                            value={this.state.newCompany.manager}
                                                            onChange={this.onInputChange}
                                                        />
                                                        {this.showErrors('manager')}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="6">
                                                    <FormGroup>
                                                        <Label for="email">{I18n[lang].email}</Label>
                                                        <Input
                                                            type="text"
                                                            name="email"
                                                            id="email"
                                                            value={this.state.newCompany.email}
                                                            onChange={this.onInputChange}
                                                        />
                                                        {this.showErrors('email')}
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" md="12" lg="6">
                                                    <FormGroup>
                                                        <Label for="types">{I18n[lang].phone}</Label>
                                                        <Input
                                                            type="text"
                                                            name="phone"
                                                            id="phone"
                                                            defaultValue={this.state.newCompany.phone}
                                                            onChange={this.onInputChange}
                                                        />
                                                        {this.showErrors('phone')}
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="6">
                                                    <FormGroup>
                                                        <Label for="skype">{I18n[lang].skype}</Label>
                                                        <Input
                                                            type="text"
                                                            name="skype"
                                                            id="skype"
                                                            value={this.state.newCompany.skype}
                                                            onChange={this.onInputChange}
                                                        />
                                                        {this.showErrors('skype')}
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="12" md="12" lg="6">
                                                    <FormGroup>
                                                        <Label for="status">{I18n[lang].status}</Label>
                                                        <Input
                                                            type="select"
                                                            name="status"
                                                            id="status"
                                                            value={this.state.newCompany.status}
                                                            onChange={this.onInputChange}
                                                        >
                                                            <option value=""></option>
                                                            <option
                                                                value={NOT_APPROVED}>{I18n[lang].statusPending}</option>
                                                            <option value={ACTIVE}>{I18n[lang].statusActive}</option>
                                                            <option value={BLOCKED}>{I18n[lang].statusBlocked}</option>
                                                        </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup>
                                                        <CustomInput
                                                            className="passwdCheckbox"
                                                            type="checkbox"
                                                            id="passwdCheckbox"
                                                            label={I18n[lang].defaultPasswd}
                                                            checked={this.state.isShowDefaultPassword}
                                                            onChange={this.onPasswordShowChange}
                                                        />
                                                        {
                                                            this.state.isShowDefaultPassword ? (
                                                                <div>
                                                                    <Input
                                                                        type="text"
                                                                        name="newUserDefaultPassword"
                                                                        id="newUserDefaultPassword"
                                                                        value={this.state.newCompany.newUserDefaultPassword}
                                                                        onChange={this.onInputChange}
                                                                    />
                                                                    {this.showErrors('newUserDefaultPassword')}
                                                                </div>
                                                            ) : ""
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12" md="12" lg="12">
                                                    <FormGroup className='new-attr__buttons'>
                                                        <Button color="secondary" className="ml-1"
                                                                onClick={this.clearNewCompanyState}>{I18n[lang].cancel}</Button>
                                                        <Button color="primary" className={`${
                                                            this.isFormValid() && this.state.editMode ? '' : 'disabled'}`}
                                                                type="submit">{I18n[lang].save}</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchCompanies: query => dispatch(fetchCompanies(query)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        delCompany: companyId => dispatch(delCompany(companyId)),
        updateSingleCompany: company => dispatch(updateSingleCompany(company)),
        updateCompanyAttributes: attributes => dispatch(updateCompanyAttributes(attributes)),
        uploadCompanyLogo: (companyId, logo) => dispatch(uploadCompanyLogo(companyId, logo)),
        deleteCompanyLogo: companyId => dispatch(deleteCompanyLogo(companyId)),
        fetchCountries: query => dispatch(fetchCountries(query)),
        fetchCities: query => dispatch(fetchCities(query)),
        fetchCompanyAvailableLanguages: () => dispatch(fetchCompanyAvailableLanguages())
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    companies: state.companiesReducer.companies,
    loading: state.companiesReducer.loading,
    currentUser: state.currentUser,
    authority: state.currentUser.roles[0].authority || GUEST,
    lang: state.languageReducer.lang,
    countriesList: state.countriesList.countries,
    citiesList: state.citiesList.cities,
    companyLanguages: state.companyLanguageReducer.companyLanguages
});

export default connect(mapStateToProps, mapDispatchToProps)(Company)



// WEBPACK FOOTER //
// ./src/components/Company/Company.js